import { render, staticRenderFns } from "./ComexShipmentForm.vue?vue&type=template&id=6391a7a8&"
import script from "./ComexShipmentForm.vue?vue&type=script&lang=js&"
export * from "./ComexShipmentForm.vue?vue&type=script&lang=js&"
import style0 from "./ComexShipmentForm.vue?vue&type=style&index=0&id=6391a7a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports